import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

import { BaseComponent, UserService, ProductService } from "@mypxplat/xplat/core";
import { Product } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { SphereSubscribeStripeComponent } from "../sphere-subscribe-stripe/sphere-subscribe-stripe.component";

@Component({
  selector: "myp-redeem-hardware-offer",
  templateUrl: "redeem-hardware-offer.component.html",
})
export class RedeemHardwareOfferComponent extends BaseComponent {
  @Input() parentProduct: Product;
  @Input() offers: Array<any>;
  @Output() redeemed: EventEmitter<boolean> = new EventEmitter();
  public displayOffers: Array<any>;
  public redeeming: boolean = false;
  public gettingProducts: boolean = false;
  public includesSphere: boolean = false;
  public selectedOffer: any;
  public sphereTermSelected: string = "Monthly";
  public sphereCouponCodes: Array<string>;
  public mutedOffers: any;
  public sphereDiscountPercent: number;
  public annualPrice: any;
  public monthlyPrice: any;
  constructor(
    userService: UserService,
    public productService: ProductService,
    private _translate: TranslateService,
    public appService: AppService,
    public activeModal: NgbActiveModal,
    public router: Router
  ) {
    super(userService);
  }

  ngOnInit() {
    let sphereProducts = this.offers.filter((item) => item.product.stringId.indexOf("sphere") > -1);
    this.mutedOffers = this.offers.filter(
      (item) =>
        item.title.indexOf("Studio One 5 Artist") > -1 ||
        item.title.indexOf("Studio One 5 Prime") > -1 ||
        item.title.indexOf("Studio One 6 Artist") > -1 ||
        item.title.indexOf("Studio One 6 Prime") > -1
    );
    if (sphereProducts.length) {
      this.sphereDiscountPercent = parseInt(sphereProducts[0].coupon_code.slice(-2));
      this.monthlyPrice = (19.99 - (19.99 * this.sphereDiscountPercent) / 100).toFixed(2);
      this.annualPrice = (179.99 - (179.99 * this.sphereDiscountPercent) / 100).toFixed(2);
    } else {
      this.mutedOffers = false;
    }
    this.displayOffers = [];
    if (sphereProducts && sphereProducts.length == 2) {
      this.includesSphere = true;
      this.displayOffers = [
        {
          title: "Studio One+",
        },
      ];
      this.sphereCouponCodes = [];
      sphereProducts.forEach((item) => {
        this.sphereCouponCodes.push(item.coupon_code);
      });
    }

    if (!this.mutedOffers) {
      this.displayOffers = [...this.displayOffers, ...this.offers.filter((item) => item.product.stringId.indexOf("sphere") < 0)];
    }
    this.selectOffer(this.displayOffers[0]);
  }

  selectOffer(offer) {
    this.clearSelectedOffers();
    offer.selected = true;
    this.selectedOffer = offer;
  }

  clearSelectedOffers() {
    this.displayOffers.forEach((item) => (item.selected = false));
  }

  subscribe() {
    this.activeModal.close();
    const modalRef = this.appService.showModal(SphereSubscribeStripeComponent, {
      size: "xl",
      backdrop: "static",
    });
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.coupons = this.sphereCouponCodes;
    modalRef.componentInstance.groupId = this.parentProduct.id;
    modalRef.componentInstance.term = this.sphereTermSelected.toLowerCase();
  }

  redeem() {
    const go = () => {
      this.redeeming = true;
      let options: any = false;
      let variant: any = false;
      if (this.selectedOffer.product.stringId.indexOf(".oem") > -1) {
        options = 64;
        variant = "Studio Magic";
      }
      this.productService.redeemProduct(this.selectedOffer.product.id, false, this.parentProduct.id, false, options, variant).subscribe((redeemResult) => {
        this.productService.getProducts(true).subscribe((result) => {
          this.redeeming = false;
          this.router.navigate(["products/detail/", redeemResult.asset ? redeemResult.asset.licenseId : redeemResult.licenseId]);
          this.redeemed.next(true);
          this.activeModal.close();
        });
      });
    };
    if (this.selectedOffer?.title == "Studio One+") {
      this.subscribe();
    } else {
      if (this.includesSphere) {
        let msg = this._translate.instant("newdash.are_you_sure_free_redeem", { title: this.selectedOffer?.title });
        if (confirm(msg)) {
          go();
        } else {
          this.selectOffer(this.displayOffers[0]);
        }
      } else {
        go();
      }
    }
  }
}
